<template>
  <div id="work-license-dialog">
    <!-- 上岗证预览界面 -->
    <div class="c1">
      <div class="line">
        <div class="title">姓名:</div>
        <div class="value">{{ data.name }}</div>
      </div>
      <div class="line">
        <div class="title">部门:</div>
        <div class="value">{{ data.department }}</div>
      </div>
      <div class="line">
        <div class="title">上岗证编号:</div>
        <div class="value">{{ data.number }}</div>
      </div>
      <div class="line">
        <div class="title">出生年月:</div>
        <div class="value">{{ data.birthday }}</div>
      </div>
    </div>
    <div class="c3">
      <div class="icon">
        <img :src="data.icon" alt="" />
      </div>
    </div>
    <div class="c2">
      <div class="line">
        <div class="title">入伍年月:</div>
        <div class="value">{{ data.armyDate }}</div>
      </div>
      <div class="line">
        <div class="title">学历:</div>
        <div class="value">{{ data.education }}</div>
      </div>
    </div>
    <div class="c2">
      <div class="line">
        <div class="title">专业:</div>
        <div class="value">{{ data.professional }}</div>
      </div>
      <div class="line">
        <div class="title">工种/岗位:</div>
        <div class="value">{{ data.station }}</div>
      </div>
    </div>
    <div class="c2">
      <div class="line">
        <div class="title">考核成绩:</div>
        <div class="value">{{ data.grade }}</div>
      </div>
      <div class="line">
        <div class="title">发证日期:</div>
        <div class="value">{{ data.time }}</div>
      </div>
    </div>
    <div class="c2">
      <!-- <div class="line">
        <div class="title">有效期:</div>
        <div class="value">{{ data.armyDate }}</div>
      </div> -->
      <div class="line">
        <div class="title">考核意见:</div>
        <div class="value">{{ data.opinion }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "diy_dialog_work_license",
  props: {
    workId: {
      type: String, // 学员上岗关系ID
      default: "",
    },
  },
  data() {
    return {
      data: {
        name: "", // 姓名
        department: "", // 部门
        number: "", // 上岗证编号
        station: "", //工种/岗位
        grade: "", // 考核成绩
        time: "", // 发证日期
        opinion: "", // 考核意见
        education: "", // 学历
        armyDate: "", // 入伍年月
        birthday: "", // 出生年月
        icon: "", // 头像
        professional: "", // 专业
      },
    };
  },
  methods: {
    /**
     * 获取学员上岗证详情
     */
    async getWorkLicenseDetailsByUserId() {
      try {
        let resultData = await this.$request({
          url: "/workLicense/getWorkLicenseDetailsByUserId",
          method: "post",
          data: { workId: this.workId },
        });
        this.data = resultData;
      } catch (error) {
        this.$message.error(error.message);
      }
    },
  },
  async mounted() {
    await this.getWorkLicenseDetailsByUserId();
  },
};
</script>

<style lang="less" scoped>
#work-license-dialog {
  width: 100%;
  height: auto;
  display: flex;
  flex-wrap: wrap;
  > .c1 {
    width: 0;
    flex: 1;
    height: auto;
    display: flex;
    flex-direction: column;
    > .line {
      width: 100%;
    }
  }
  > .c2 {
    width: 100%;
    height: auto;
    display: flex;
    > .line {
      width: 0;
      flex: 1;
    }
  }
  > .c3 {
    width: 150px;
    > .icon {
      width: 100%;
      height: 170px;
      padding: 4px;
      box-sizing: border-box;
      border: 1px solid #a1a1a1;
      > img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .line {
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 10px;
    > .title {
      width: 80px;
      font-size: 13px;
      font-weight: bold;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      margin-right: 5px;
    }
    > .value {
      width: 0;
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      font-size: 14px;
    }
  }
}
</style>